import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useTranslation } from "react-i18next";
import preval from 'preval.macro'
import moment from "moment";
import { getFromatdate } from "../../../_helpers/GlobalHelpers";
import ReleaseNote from "../../../../app/ReleaseNote/ReleaseNote";

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();
  const { t } = useTranslation();
 const [show , setShow] = useState(false);
  const layoutProps = useMemo(() => {
    return {
      footerLayout: objectPath.get(uiService.config, "footer.layout"),
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true),
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Footer */}
      {/* doc: add "bg-white" class to have footer with solod background color */}
      <div
        className={`footer py-4 d-flex flex-lg-column ${layoutProps.footerClasses}`}
        id="kt_footer"
      >
        {/* begin::Container */}
        <div
          className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
        >
          {/* begin::Copyright */}
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold mr-">
              {today} &copy;
            </span>
            {` `}
            <a
              href={() => false}
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              DeliveryEase{"  "}
            </a>
            <span className="text-muted mr-2 cursor-pointer"
              onClick={() => setShow(true)}
            >
              Build Version{" "}
              <span
                target="_blank"
                rel="noopener noreferrer"
                className="font-weight-bolder text-muted"
              >
                {process.env.REACT_APP_VERSION}
              </span>{" "}
              / Build Date:{" "}
              <strong>{moment(preval`module.exports = new Date().toLocaleDateString("en-US");`).format(getFromatdate())}</strong>

            </span>
          </div>
          {/* end::Copyright */}
          {` `}
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2">
            <a
              href="https://deliveryease.co/terms-conditions.html"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link px-3"
            >
              Terms & Conditions
            </a>
            <a
              href="https://deliveryease.co/privacy-policy.html"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link px-3"
            >
              Privacy Policy
            </a>
            <a
              href="https://deliveryease.co/contact-us.html"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link pl-3 pr-0"
            >
              Contact
            </a>
          </div>
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
      <ReleaseNote  show={show} setShow={setShow}/>
    </>
  );
}
